module.exports = "../dist/img/product-detail-3-26.bbe0.jpg";